export default class Robot {
  constructor(color, disabledList, location){
    this.color = color
    this.location = location || generateLocation(disabledList);
  }
};
  
function generateLocation(disabledList) {
  var isMatch= false;
  var location = [Math.floor(Math.random()*16), Math.floor(Math.random()*16)]
  disabledList.forEach(function(disabledLocation){
    if(location[0] === disabledLocation[0] && location[1] === disabledLocation[1]){
      isMatch = true;
    }
  })
  if(isMatch){
    return generateLocation(disabledList);
  }
  return location;
}


// WEBPACK FOOTER //
// ./game/Robot.js